import React, { useEffect } from 'react';
import {
    MainGrid,
    OverviewSection,
    AssignmentSection
} from '../../../styles/CalculateMoney/CalculateMoneyViewStyles';
import OverviewPanelStaff from './OverviewPanelStaff';
import AssignmentPanelStaff from './AssignmentPanelStaff';
import { useWorkSessionsContext } from '../../../context/WorkSessionsContext';

const CalculateMoneyViewStaff = ({
    businessId,
    staff,
    currentWeek,
    staffId,
    services,
    categories,
    onShowSuccess,
    notifications,
    onMarkSeen
}) => {
    const {
        workSessions,
        fetchWorkSessionsByStaffData,
        createWorkSessionAndUpdateList,
        updateWorkSessionAndRefresh,
        deleteWorkSessionAndRefresh,
    } = useWorkSessionsContext();

    useEffect(() => {
        if (staffId) fetchWorkSessionsByStaffData(staffId);
    }, [staffId, fetchWorkSessionsByStaffData]);

    return (
        <MainGrid>
            <OverviewSection>
                <OverviewPanelStaff
                    businessId={businessId}
                    currentWeek={currentWeek}
                    staff={staff}
                    workSessions={workSessions}
                    staffId={staffId}
                    services={services}
                    categories={categories}
                />
            </OverviewSection>

            <AssignmentSection>
                <AssignmentPanelStaff
                    businessId={businessId}
                    staffId={staffId}
                    staff={staff}
                    workSessions={workSessions}
                    createWorkSession={createWorkSessionAndUpdateList}
                    updateWorkSession={updateWorkSessionAndRefresh}
                    deleteWorkSession={deleteWorkSessionAndRefresh}
                    services={services}
                    categories={categories}
                    onShowSuccess={onShowSuccess}
                    notifications={notifications}
                    onMarkSeen={onMarkSeen}
                />
            </AssignmentSection>
        </MainGrid>
    );
};

export default CalculateMoneyViewStaff;